/**
 * appsflyer에서 자동생성한 코드입니다.
 * @see https://dev.appsflyer.com/hc/docs/dl_smart_script_v2#embed-the-script-in-your-website
 * @see https://hq1.appsflyer.com/smart-script/overview
 **/
export function getAppsflyerDownloadUrl(): string | null {
  if (!window.AF_SMART_SCRIPT) {
    return null;
  }

  const oneLinkURL = 'https://azarlive.onelink.me/fHTc';
  const mediaSource = { keys: ['pid'], defaultValue: 'any_source' };
  const ad = { keys: ['p5'] };
  const adSet = { keys: ['p3'] };
  const campaign = { keys: ['p1'] };
  const af_c_id = { paramKey: 'af_c_id', keys: ['p2'] };
  const af_adset_id = { paramKey: 'af_adset_id', keys: ['p4'] };
  const af_ad_id = { paramKey: 'af_ad_id', keys: ['p6'] };
  const fbclid = { paramKey: 'fbclid', keys: ['fbclid'] };
  const custom_ss_ui = { paramKey: 'af_ss_ui', defaultValue: 'true' };

  // Call the function after embedding the code through a global parameter on the window object called window.AF_SMART_SCRIPT.
  // Onelink URL is generated.
  const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
    oneLinkURL,
    afParameters: {
      mediaSource,
      ad,
      adSet,
      campaign,
      afCustom: [af_c_id, af_adset_id, af_ad_id, fbclid, custom_ss_ui],
    },
  });

  return result ? result.clickURL : null;
}
